<template>
  <div class="logs-box" @scroll="onScroll">
    <transition name="slide-up">
      <div class="date-range" v-show="showDateRange">
        <div class="row">
          <div class="column small-6">
            <datepicker :format="calendarFormat" class="datepicker small inline"
              v-model="date.from" v-on:input="changeDate('from')"
              :disabled-picker="loading" :input-class="{'datepicker-empty':error.from}"
              :placeholder="$t('transactions.filter.from')"></datepicker>
          </div>
          <div class="column small-6">
            <datepicker :format="calendarFormat" class="datepicker small inline left-side"
              v-model="date.to" v-on:input="changeDate('to')"
              :disabled-picker="loading" :input-class="{'datepicker-empty':error.to}"
              :placeholder="$t('transactions.filter.to')"></datepicker>
          </div>
        </div>
        <transition name="slide-up">
          <span class="error-msg" v-if="!!error.message">{{ error.message }}</span>
        </transition>
        <button class="cta button block xsmall success" @click="dateApply">Submit</button>
      </div>
    </transition>

    <div class="list">
      <div v-for="(log, i) in logs" :key="i" @click="log.show = !log.show"
        :class="{'action':true, 'collapsed':log.collapsed}"
        v-show="log.action !== 'admin_edit_provider' || (log.action === 'admin_edit_provider' && log.details.changes.length)">
        <div class="minimize">
          <div class="icon-display">
            <i class="fa fa-plus-circle" v-if="!log.show"></i>
            <i class="fa fa-minus-circle" v-else></i>
          </div>
          <div class="action-display">
            <span>{{log.created}}</span>
            <div class="log-heading">{{ title(log) }}</div>
          </div>
        </div>
        <!-- {{log}} -->
        <transition name="slide-down">
          <div v-show="log.show" class="action-item">
            <div class="icon-display"></div>
            <div class="action-display">
              <div class="log-details">
                <div v-if="showPkgId.indexOf(log.action) > -1 || log.details.packageID" class="log-data">
                  Package ID: 
                  <a :href="`#/package/${log.details.packageID}`" target="_blank">{{log.details.packageID}}</a>
                </div>

                <div v-if="showRsvpId.indexOf(log.action) > -1" class="log-data">
                  Reservation ID: 
                  <a :href="`#/reservation/${log.rsvpId}`" target="_blank">{{log.rsvpId}}</a>
                </div>

                <div v-if="log.action === 'driver_release'" class="log-data">
                  Cancellation Fee: <b>${{ toFixed(log.details.fee.Charge) }}</b>
                </div>

                <div v-if="log.action === 'admin_edit_provider'">
                  <div class="log-data">Admin ID: <b>{{log.details.adminId}}</b></div>
                  <div class="log-data">Admin Name: <b>{{log.details.adminName}}</b></div>
                  <div class="log-data">Admin Email: <b>{{log.details.adminEmail}}</b></div>

                  <br/>

                  <div v-for="(detail, index) in log.details.changes" class="log-data" :key="index">
                    <div v-if="['profile.businessSSN', 'profile.businessSSNUrl', 'profile.businessEIN', 'profile.businessEINUrl'].indexOf(detail.property) > -1">
                      <b>Admin updated {{ fieldLabel[detail.property] }}.</b>
                    </div>
                    <div v-else>
                      <b>{{ fieldLabel[detail.property] || detail.property }}</b>
                      <div>
                        {{ detail.old }}
                        <i class="fas fa-chevron-right"></i>
                        <b>{{ detail.new }}</b>
                      </div>
                      <br/>
                    </div>
                  </div>
                </div>

                <!-- <div v-if="log.action === 'resend_email_prov'" class="log-data">
                  Recipient: <b>{{ log.details.email.email.message.to }}</b>
                </div> -->
              </div>
            </div>
          </div>
        </transition>
      </div>

      <transition name="slide-down">
        <div class="loader" v-if="loading">
          <i class="fas fa-spinner fa-spin"></i> Loading...
        </div>
      </transition>

      <div class="empty-state" v-show="logs.length === 0 && !loading">
        <i class="fa fa-clipboard-list fa-4x"></i>
        <span>{{ $t('rsvpDetails.activityLogs.emptyState') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import services from '@/modules/api/services'
import featureToggle from '@/modules/api/featureToggle'

export default {
  name: 'activity-history',
  components: { datepicker },
  data () {
    return {
      heading: {
        admin_edit_provider: 'Admin made an update',
        driver_accept: 'Accepted the reservation',
        driver_noshow: 'Set the reservation as No Show',
        driver_ontheway: 'Set the reservation as On the Way',
        driver_release_attempt: 'Attempted to release the reservation',
        driver_release: 'Released the reservation',
        driver_reject: 'Rejected the reservation',
        driver_arrived: 'Set the reservation as Arrived at Pickup',
        driver_onboard: 'Set the reservation as On Board',
        driver_complete: 'Marked the reservation as Completed',
        resend_email_prov: 'Resend email: Reservation Completed',
        asap_accepted: 'Accepted an ASAP request',
        package_release: 'Released the package',
        package_reject: 'Rejected the package',
        package_accept: 'Accepted the package'
      },
      showRsvpId: [
        'driver_accept', 'driver_noshow', 'driver_ontheway',
        'driver_release_attempt', 'driver_release', 'driver_reject',
        'driver_arrived', 'driver_onboard', 'driver_complete',
        'resend_email_prov', 'asap_accepted', 'package_release',
        'package_reject', 'package_accept'
      ],
      showPkgId: ['package_release', 'package_reject', 'package_accept'],
      fieldLabel: {
        'profile.businessName': 'Business Name',
        'profile.businessType': 'Typo of Business',
        'profile.businessSSN': 'SSN',
        'profile.businessSSNUrl': 'SSN Image',
        'profile.businessEIN': 'EIN',
        'profile.businessEINUrl': 'EIN Image',
      },
      showDateRange: false,
      date: {
        from: '',
        to: ''
      },
      error: {
        from: false,
        to: false,
        message: ''
      }
    }
  },
  computed: {
    provId () { return this.$route.params.id },
    logs () { return this.$store.state.provider.logs.activityHistory.list },
    loading () { return this.$store.state.provider.logs.activityHistory.loading },
    reachMax () { return this.$store.state.provider.logs.activityHistory.reachMax }
  },
  methods: {
    getLogs () {
      let self = this
      if (self.loading || self.reachMax) { return }

      self.$store.commit('provider/setActivityHistoryField', {
        fields: { loading: true }
      })

      let logsData = this.$store.state.provider.logs.activityHistory
      let params = {
        token: self.$store.state.session.sessionToken,
        pageNum: logsData.pageNum,
        pageSize: logsData.pageSize,
        order: 'created',
        orderAsc: 0
      }
      if (logsData.since) {
        params.since = moment(logsData.since, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00:00')
        params.until = moment(logsData.until, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59:59')
      }

      self.$sdk.get(`/provider/${self.provId}/event`, params, res => {
        self.$store.commit('provider/setActivityHistoryField', {
          fields: { loading: false }
        })

        if (!res.error) {
          if (!res.list.length) {
            self.$store.commit('provider/setActivityHistoryField', {
              fields: { reachMax: true }
            })
            return
          }

          let actions = {}
          res.list.forEach(log => {
            if (!actions[log.action]) { actions[log.action] = 0 }
            actions[log.action] = actions[log.action] + 1

            log.created = moment(log.created, 'X').format('MM/DD/YYYY hh:mm:ss A')
            // let tempLog = log
            // tempLog.created = moment(tempLog.created, 'X').format('MM/DD/YYYY hh:mm:ss A')
            let showDefault = {show: false}
            self.$store.commit('provider/addActivityHistory', {...log, ...showDefault})
          })
        }
      })
    },
    title (data) {
      if (data.action === 'driver_accept' && data.details.packageID) {
        return this.heading.package_accept
      }

      return this.heading[data.action] || data.action
    },
    toFixed (x) { return parseFloat(x).toFixed(2) },
    onScroll (event) {
      let scrollAndView = event.target.scrollTop + event.target.offsetHeight
      if (event.target.scrollHeight - scrollAndView < 150) {
        this.loadMore()
      }
    },
    loadMore () {
      let self = this
      if (self.loading) { return }

      self.$store.commit('provider/setActivityHistoryField', {
        fields: { pageNum: self.$store.state.provider.logs.activityHistory.pageNum + 1 }
      })
      self.getLogs()
    },
    dateToggle (val) {
      this.showDateRange = val === 'custom'
      if (val === 'all') {
        this.$store.commit('provider/setActivityHistoryField', {
          fields: {
            pageNum: 1,
            list: [],
            since: null,
            until: null,
            reachMax: false
          }
        })
        this.getLogs()
      }
    },
    calendarFormat (date) { return moment(date).format('MM/DD/YYYY') },
    changeDate (type) {
      let format = 'MM/DD/YYYY'
      let from = ''
      let to = ''

      if (type === 'from') {
        this.error.from = false
        from = moment(this.date.from)
        this.$store.commit('provider/setActivityHistoryField', {
          fields: { since: from.format(format) }
        })
        if (this.date.to) { to = moment(this.date.to, format) }
      } else {
        this.error.to = false
        to = moment(this.date.to)
        this.$store.commit('provider/setActivityHistoryField', {
          fields: { until: to.format(format) }
        })
        if (this.date.from) { from = moment(this.date.from, format) }
      }
    },
    dateApply () {
      if (this.loading) { return }

      this.error = {
        from: false,
        to: false,
        message: ''
      }

      if (this.date.from === '' || this.date.to === '') {
        if (this.date.to === '') { this.error.to = true }
        if (this.date.from === '') { this.error.from = true }
        this.error.message = this.$t('transactions.filter.emptyDate')
        return
      }

      let from = moment(this.date.from)
      let to = moment(this.date.to)
      if (from.format('x') > to.format('x')) {
        this.error.from = true
        this.error.to = true
        this.error.message = this.$t('transactions.filter.invalidDateRange')
        return
      }

      this.$store.commit('provider/setActivityHistoryField', {
        fields: {
          pageNum: 1,
          list: [],
          since: from.format('MM/DD/YYYY'),
          until: to.format('MM/DD/YYYY'),
          reachMax: false
        }
      })
      this.getLogs()
    }
  },
  watch: {
    provId: function (value) {
      this.$store.commit('provider/setActivityHistoryField', {
        fields: {
          pageNum: 1,
          list: [],
          since: null,
          until: null,
          reachMax: false
        }
      })
      this.getLogs()
    }
  },
  mounted () {
    this.getLogs()
  }
}
</script>

<style lang="scss" scoped>

.logs-box{
  background: #fff;
}

.list{
  margin-top: 15px;
}

.date-range{
  padding: 20px;
  background: #fafafa;
  border-bottom: 1px solid #eee;
  transform-origin: top center;

  .small-6:first-child{ padding-right: 10px; }
  .datepicker{ margin-bottom: 5px; }
  .error-msg{
    background: #ff6115;
    border-radius: 3px;
    font-size: 13px;
    color: #fff;
    display: block;
    padding: 4px;
    margin-bottom: 7px;
    font-style: italic;
    transform-origin: top center;
  }
}

.action{
  border: 1px solid #ddd;
  width: 100%;
  max-height:auto;
  padding: 10px;
  background: #fafafa;
  overflow: hidden;
  transition: all .35s ease-in-out;
  cursor: pointer;
  margin-bottom: 10px;

  &:hover { background: #fff8dc; }
  &.collapsed{
    padding: 10px;
    background: #fff8dc;
  }

  .log-heading {
    margin: 0;
    font-weight: 600;
  }
  .action-item {
    padding-left: 15px;
    transform-origin: top center;

    .icon-display {
      float: left;
      width: 5%;
      i {
        font-size: 11px;
        color: #666;
      }
    }

    .action-display {
      float: left;
      width: 95%;
      margin-top: 10px;
    }

    .log-details {
      font-size: 11px;
      color: #666;
    }
    .log-data{
      margin-bottom: 2px;
    }
  }

  .minimize {
    font-size: 11px;
    color: #666;
    content: "";
    clear: both;

    .icon-display {
      float: left;
      width: 5%;
      i {
        font-size: 11px;
        color: #666;
      }
    }

    .action-display {
      float: left;
      width: 95%;
      p {
        margin: 0;
      }
    }

  }
}

.loader{
  text-align: center;
  padding: 10px;
  font-size: 21px;
  color: #bbb;
  font-weight: 600;

  i{ margin-right: 3px; }
}

.empty-state{
  padding: 30px;
  font-size: 18px;
  color: #999;
  text-align: center;

  .fa{
    display: block;
    margin-bottom: 5px;
    color: #ccc;
    text-shadow:0 0 5px rgba(255,255,255, 1);
  }
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .2s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .3s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

.service-label{
  line-height: 100%;
  color: #fff;
  padding: 3px 5px;
  border-radius: 3px;
  font-weight: 700;
  font-size: 12px;
  display: inline-block;
  margin-top: 2px;
  text-transform: capitalize;

  &.shared{ background: #f38d56; }
  &.opoli{ background: #26D97A; }
  &.black{ background: #777; }
  &.SUV, &.suv{ background: #dc3168; }
  &.shuttle{ background: #6dabc3; }
}
</style>



// WEBPACK FOOTER //
// src/components/Provider/ActivityHistory.vue